export const mapToBankAccountClPayload = (formValues) => {
  return {
    account_document_type: 'RUT',
    id_bank: formValues.bank.value,
    account_data: {
      rut: formValues.rut,
      account_type: formValues.accountType.value,
      account_number: formValues.accountNumber,
    },
  };
};
